import React from 'react';
import { NavLink } from 'react-router-dom';
import { css, cx } from 'emotion';
import { TEXT_GRAY, DARK_GRAY, GRAY } from 'config/colors';
import { RouteUrls } from 'routes/RouteConstants';
import { connect, RootStateOrAny } from 'react-redux';
import { selectClientConfigurations } from 'state/user/selectors';
import { AppFeaturePermissions, usePermissions } from 'contexts';

const navbar = css`
    width: 100%;
    background-color: ${GRAY};
    min-height: 40px;
    padding-top: 10px;
    border-bottom: 1px solid ${DARK_GRAY};
    overflow: hidden;
`;

const button = css`
    padding: 12px 16px;
    font-size: 14px;
    border: 1px solid ${DARK_GRAY};
    text-decoration: none;
    color: ${TEXT_GRAY};
    &:hover,
    &:active,
    &:focus {
        text-decoration: none;
        color: ${TEXT_GRAY};
    }
`;

const activeButton = css`
    color: ${TEXT_GRAY};
    font-weight: bold;
    background-color: #e5e6e7;
`;

interface PlanningNavbarProps {
    className?: string;
    capitalTrackerEnabled: boolean;
}

const PlanningNavbar = ({
    className,
    capitalTrackerEnabled,
}: PlanningNavbarProps) => {
    const { featurePermissions } = usePermissions();

    const showCapitalProjects = featurePermissions.includes(
        AppFeaturePermissions.CapitalProjects
    );
    const showPrioritiesObjectives = featurePermissions.includes(
        AppFeaturePermissions.PrioritiesAndObjectives
    );
    const showServiceContracts = featurePermissions.includes(
        AppFeaturePermissions.Contracts
    );
    const showHoldSell = featurePermissions.includes(
        AppFeaturePermissions.HoldSell
    );

    return (
        <div className={cx([navbar, className])}>
            {showCapitalProjects && capitalTrackerEnabled && (
                <NavLink
                    to={RouteUrls.PLANNING_CAPITAL_TRACKER}
                    className={button}
                    activeClassName={activeButton}
                >
                    Capital Projects
                </NavLink>
            )}
            {showPrioritiesObjectives && (
                <NavLink
                    to={RouteUrls.PLANNING_PRIORITIES_AND_OBJECTIVES}
                    className={button}
                    activeClassName={activeButton}
                >
                    Priorities & Objectives
                </NavLink>
            )}
            {showServiceContracts && (
                <NavLink
                    to={RouteUrls.PLANNING_SERVICE_CONTRACTS}
                    className={button}
                    activeClassName={activeButton}
                >
                    Service Contracts
                </NavLink>
            )}

            {showHoldSell && (
                <NavLink
                    to={RouteUrls.PLANNING_HOLD_SELL}
                    className={button}
                    activeClassName={activeButton}
                >
                    Hold/Sell
                </NavLink>
            )}
        </div>
    );
};

const mapState = (state: RootStateOrAny) => {
    const clientConfig = selectClientConfigurations(state);
    const { FEATURE_CAPITAL_TRACKER: capitalTrackerEnabled } = clientConfig;
    return {
        capitalTrackerEnabled,
    };
};

export default connect(mapState)(PlanningNavbar);
